import { keepPreviousData, useQuery } from '@tanstack/react-query';
import type { InventoryCockpit, ItemResponse } from '@proerp/shared';
import { apiRequest } from '@/lib/apiClient';

export const INVENTORY_COCKPIT_KEY = ['inventory-cockpit'] as const;

export interface InventoryCockpitParams {
  horizonDays: number;
  /** Hauptwarengruppe (1000er-Band); null/undefined = alle. */
  commodityMainGroup?: number | null;
}

/**
 * Lagercockpit — ein Aufruf, alles fertig gerechnet (Server). Die alte Antwort
 * bleibt beim Umschalten von Horizont/Warengruppe stehen (`keepPreviousData`),
 * damit die Kacheln nicht flackern; alle fünf Minuten wird still nachgeladen.
 */
export function useInventoryCockpit(params: InventoryCockpitParams) {
  const search = new URLSearchParams({ horizonDays: String(params.horizonDays) });
  if (params.commodityMainGroup != null) search.set('commodityMainGroup', String(params.commodityMainGroup));
  return useQuery({
    queryKey: [...INVENTORY_COCKPIT_KEY, params.horizonDays, params.commodityMainGroup ?? null],
    queryFn: () => apiRequest<ItemResponse<InventoryCockpit>>(`/v1/inventory/cockpit?${search.toString()}`).then((r) => r.data),
    placeholderData: keepPreviousData,
    staleTime: 60_000,
    refetchInterval: 5 * 60_000,
  });
}
